<template>
  <v-container fill-height>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 text-xs-center>
        <v-alert class="text-center" value="true" color="info" icon="help" outline>
          <i18n class="pre-formatted" path="info-when-no-device" tag="span">
            <router-link place= "link" to="/help">{{$t('info-when-no-device-click')}}</router-link>
          </i18n>

        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap;
}
</style>